import api from '@/api/graylog';
import store from '@/store';
import * as types from './types';

export default {
  resetResult(context) {
    context.commit(types.SET_RESULT, { messages: [] });
  },
  getMatchesLogs(context, params) {
    context.commit(types.SET_RESULT, { messages: [] });
    return api.search(params).then((response) => {
      const data = response;
      context.commit(types.SET_RESULT, data);
      return Promise.resolve(response);
    }).catch((err) => {
      context.commit(types.SET_RESULT, { messages: [] });
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Recommencez', type: 'error' });
      return Promise.reject(err);
    });
  },
  getRelativeMatchesLogs(context, params) {
    context.commit(types.SET_RESULT, { messages: [] });
    return api.searchRelative(params).then((response) => {
      const data = response;
      context.commit(types.SET_RESULT, data);
      return Promise.resolve(response);
    }).catch((err) => {
      context.commit(types.SET_RESULT, { messages: [] });
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Recommencez', type: 'error' });
      return Promise.reject(err);
    });
  },
  pushLogsInResult(context, params) {
    return api.search(params).then((response) => {
      const data = response.messages;
      context.commit(types.PUSH_RESULT, data);
      return Promise.resolve(response);
    }).catch((err) => {
      context.commit(types.SET_RESULT, { messages: [] });
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Recommencez', type: 'error' });
      return Promise.reject(err);
    });
  },
  getMailsInvalidsLogs(context) {
    context.commit(types.SET_RESULT, { messages: [] });
    return api.searchMailsInvalids().then((response) => {
      const data = response;
      context.commit(types.SET_RESULT, data);
      return Promise.resolve(response);
    }).catch((err) => {
      context.commit(types.SET_RESULT, { messages: [] });
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Recommencez', type: 'error' });
      return Promise.reject(err);
    });
  },
};
